import React, { useEffect, useState } from "react";
import {
  Button,
  Collapse,
  Descriptions,
  Divider,
  Form,
  Input,
  notification,
  Spin,
  Switch,
  Table,
  Tag,
  Typography,
} from "antd";
import { get, put } from "../../../api/axios";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { checkPermission } from "../../control-sections/auth/ProtectedRoutes";

const { Title } = Typography;
const { Panel } = Collapse;

const ShowSellers = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [fromLoading, setFromLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sellerProfile, setSellerProfile] = useState([]);
  const [listings, setListings] = useState([]);
  const [leads, setLeads] = useState([]);

  const columnsForListings = [
    { title: "Id", dataIndex: "id" },
    { title: "Title", dataIndex: "title" },
    { title: "Price", dataIndex: "price" },
    { title: "Property type", dataIndex: "property_type" },
    { title: "Listing type", dataIndex: "listing_type" },
    { title: "Area", dataIndex: "area" },
    {
      title: "Is active",
      render: ({ is_active }) => (
        <>
          <Tag color={`${is_active == 1 ? "success" : "error"}`}>
            {is_active == 1 ? "Active" : "Inactive"}
          </Tag>
        </>
      ),
    },
  ];

  const columnsForLeads = [
    {
      title: " Id",
      dataIndex: "id",
    },
    {
      title: "Listing Title",
      render: ({ listing }) =>
        checkPermission("update-seller-listings") ? (
          listing ? (
            <Link to={`/listings/edit/${listing.id}`}>{listing.title}</Link>
          ) : (
            ""
          )
        ) : listing.title ? (
          listing.title
        ) : (
          ""
        ),
    },
    {
      title: "Seller Name",
      render: ({ seller }) =>
        checkPermission("update-seller") ? (
          seller ? (
            <Link to={`/sellers/edit/${seller.id}`}>{seller.name}</Link>
          ) : (
            ""
          )
        ) : seller.name ? (
          seller.name
        ) : (
          ""
        ),
    },
    {
      title: "Buyer Name",
      render: ({ buyer }) =>
        checkPermission("update-buyer") ? (
          buyer ? (
            <Link to={`/buyers/edit/${buyer.id}`}>{buyer.name}</Link>
          ) : (
            ""
          )
        ) : buyer.name ? (
          buyer.name
        ) : (
          ""
        ),
    },
    {
      title: "Action",
      dataIndex: "action",
    },
    {
      title: "Extra Data",
      dataIndex: "extra_data",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
    },
  ];

  useEffect(() => {
    get(`sellers/${id}`).then((res) => {
      const { listings, leads, ...rest } = res.data;
      setListings(listings);
      setLeads(leads);
      const otherDataArray = Object.entries(rest).map(([key, value]) => ({
        key,
        value,
      }));
      setSellerProfile([...otherDataArray]);
      setFromLoading(true);
    });
  }, []);

  return (
    <div>
      <Title level={2} className="text-main mb-2">
        <ArrowLeftOutlined onClick={() => navigate("/sellers")} />
        Seller Details Page
      </Title>

      {fromLoading ? (
        <div className="row">
          <Collapse defaultActiveKey={["1"]}>
            <Panel header="Seller Profile" key="1">
              {sellerProfile.length > 0 && (
                <div className="row">
                  <Descriptions bordered colon className="p-2">
                    {sellerProfile.map(
                      (item) =>
                        item.key !== "country_code" &&
                        item.key !== "phone_number" &&
                        item.key !== "nafath_id" &&
                        item.key !== "nafath_trans_id" && (
                          <Descriptions.Item label={item.key} key={item.key}>
                            {item.key == "is_active" ? (
                              <Tag
                                color={`${
                                  item.value == 1 ? "success" : "error"
                                }`}
                              >
                                {item.value == 1 ? "Active" : "Inactive"}
                              </Tag>
                            ) : item.key == "is_approved" ? (
                              <Tag
                                color={`${
                                  item.value == 1 ? "success" : "error"
                                }`}
                              >
                                {item.value == 1 ? "Approved" : "Rejected"}
                              </Tag>
                            ) : (
                              item.value
                            )}
                          </Descriptions.Item>
                        )
                    )}
                  </Descriptions>
                </div>
              )}
            </Panel>
            <Divider />
            <Panel header="Listings" key="2">
              <div className="row">
                <div className="w-100">
                  <Table
                    locale={{ emptyText: "There are no data" }}
                    loading={loading}
                    columns={columnsForListings}
                    dataSource={listings}
                    size="small"
                    responsive
                    pagination={false}
                  />
                </div>
              </div>
            </Panel>
            <Divider />
            <Panel header="Leads" key="3">
              <div className="row">
                <div className="w-100">
                  <Table
                    locale={{ emptyText: "There are no data" }}
                    loading={loading}
                    columns={columnsForLeads}
                    dataSource={leads}
                    size="small"
                    responsive
                    pagination={false}
                  />
                </div>
              </div>
            </Panel>
          </Collapse>
        </div>
      ) : (
        <div className="text-center">
          <Spin size="large" />
        </div>
      )}
    </div>
  );
};

export default ShowSellers;
